import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 需量接口
 **********************************************************************************/
export default {
	/**
	 * 查询通讯设备对应的通讯采集配置
	 */
	getDeviceCollectionConfig(no, parentarea, success, failure) {
		Axios.post('/deviceCollectionConfig/getDeviceCollectionConfig.do', {
			no,
			parentarea
		}, success, failure)
	},
	/**
	 * 查询通讯设备采集配置列表
	 */
	getDeviceCollectionConfigLimit(serverId, pageIndex,pageSize, success, failure) {
		Axios.post('/deviceCollectionConfig/getDeviceCollectionConfigLimit.do', {
			serverId,
			pageIndex,
			pageSize,
		}, success, failure)
	},
	/**
	 * 添加或更新通讯设备采集配置
	 */
	saveDeviceCollectionConfig(deviceName, deviceId,serverId,serverInfo,deviceGroup,deviceTemplate,deviceSubseries,deviceCollectionType, success, failure) {
		Axios.post('deviceCollectionConfig/saveDeviceCollectionConfig.do', {
			deviceName,
			deviceId,
			serverId,
			serverInfo,
			deviceGroup,
			deviceTemplate,
			deviceSubseries,
			deviceCollectionType,
		}, success, failure)
	},
	/**
	 * 刪除通讯设备采集配置
	 */
	deleteDeviceCollectionConfig(deviceId, success, failure) {
		Axios.post('/deviceCollectionConfig/deleteDeviceCollectionConfig.do', {
			deviceId,
		}, success, failure)
	},
}
